import React from 'react'

const StatusToggle = ({ status = true, onChange, disabled = false }) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!status)
    }
  }

  return (
    <button
      onClick={handleToggle}
      className={`w-9 h-5 bg-neutral-50 border relative rounded-[100px] border-[rgba(83,88,98,0.20)] transition-colors
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      `}
      aria-checked={status}
      role="switch"
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    >
      <div
        className={`w-4 h-4 absolute rounded-[100px] top-0.5 transition-all duration-200
          ${
            status && !disabled
              ? 'bg-[#3BBC4C] right-0.5'
              : 'bg-gray-300 left-0.5'
          }
        `}
      />
    </button>
  )
}

export default StatusToggle
